// NCB calls flow through the backend proxy — secret key never ships to the browser.
const NCB_CONFIG = {
  conversationId: 'chat-b1d879b3-909e-48fd-a869-1b3b69f467d1',
  proxyBase: 'https://rmvzorxcl35mttidiexhtp5g2m0hpsqo.lambda-url.us-east-2.on.aws',
  instance: '56134_gwa_camp'
};

export function buildProxyUrl(path) {
  const url = new URL(path, NCB_CONFIG.proxyBase);
  url.searchParams.set('Instance', NCB_CONFIG.instance);
  return url.toString();
}

async function ncbRequest(url, options = {}) {
  try {
    const response = await fetch(url, {
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        ...options.headers
      },
      ...options
    });
    const body = await response.json().catch(() => ({}));

    if (!response.ok) {
      return {
        status: 'error',
        data: null,
        error: body?.message || body?.error || `HTTP ${response.status}`,
        httpStatus: response.status
      };
    }

    if (
      body
      && typeof body === 'object'
      && !Array.isArray(body)
      && typeof body.status === 'string'
      && 'data' in body
    ) {
      return body;
    }

    return { status: 'success', data: body };
  } catch (error) {
    return {
      status: 'error',
      data: null,
      error: error?.message || 'Network error'
    };
  }
}

export function authFetch(path, options = {}) {
  return ncbRequest(buildProxyUrl(`/auth/${path}`), options);
}

export function dataFetch(path, options = {}) {
  return ncbRequest(buildProxyUrl(`/data/${path}`), options);
}

export function publicDataFetch(path, options = {}) {
  return ncbRequest(buildProxyUrl(`/public-data/${path}`), options);
}